import { AUDIT_STATUS } from '../../../utils/constants/commonValues';
import moment from 'moment';

function AuditTrailData(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

AuditTrailData.prototype = Object.assign(AuditTrailData.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.auditTrailViewList &&
            tableData.auditTrailViewList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { pageNo, totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: pageNo,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            dateAndTime,
            event,
            eventData,
            externalIpAddress,
            resource,
            status,
            userId,
        } = row;
        return {
            dateAndTime: this.convertDate(dateAndTime),
            event,
            eventData,
            externalIpAddress,
            resource,
            status: this.getStatus(status),
            userId,
        };
    },
    convertDate(timeStamp) {
        const dateString = moment(timeStamp).format('DD/MM/YYYY hh:mm a');
        return dateString;
    },

    getStatus(status) {
        if (status && AUDIT_STATUS[status]) {
            return AUDIT_STATUS[status];
        }

        return status;
    },
});

export default AuditTrailData;
